import { Box, FormControl, FormHelperText, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useContext } from "react";
import { eatoutOptions, transportRecreationOptions, utilsOptions } from "../../consts/inputs";
import { FootprintContext } from "../../pages/profile_pages/EditLifestylePage";
import InfoPopup from "../inputs/InfoPopup";
import InputField from "../inputs/InputField";
import InputLabel from "../inputs/InputLabel";

export default function Step2Inputs() {
    const [dietPrefInput, setDietPref] = useContext(FootprintContext).dietPrefInput;
    const [regularCarUse, setRegCarUse] = useContext(FootprintContext).regularCarUse;
    const [eatOutExpInput, setEatOut] = useContext(FootprintContext).eatOutExpInput;
    const [eatInExpInput, setEatIn] = useContext(FootprintContext).eatInExpInplut;
    const [transportExpInput, setTransport] = useContext(FootprintContext).transportExpInput;
    const [recreationExpInput, setRecreation] = useContext(FootprintContext).recreationExpInput;
    const [utilitiesExpInput, setUtils] = useContext(FootprintContext).utilitiesExpInput;

    return (
        <>
        <FormControl>
            <InputLabel label={'What best describes your diet?'} />
            <ToggleButtonGroup
                fullWidth
                exclusive
                value={dietPrefInput}
                onChange={(e,v) => setDietPref(v)}
                sx={{ borderRadius: '32px' }}
            >
                <ToggleButton className='rounded-toggle-btn' value={'omnivore'}>Omnivore</ToggleButton>
                <ToggleButton className='rounded-toggle-btn' value={'vegetarian'}>Vegetarian</ToggleButton>
                <ToggleButton className='rounded-toggle-btn' value={'vegan'}>Vegan</ToggleButton>
            </ToggleButtonGroup>
            <FormHelperText>
                {
                    dietPrefInput==='omnivore' ? 'Diet includes both plant and animal foods and products.'
                    : dietPrefInput==='vegetarian' ? 'Diet excludes meat or fish, but may include dairy and egg products.'
                    : dietPrefInput==='vegan' ? 'Diet includes only plant-based foods and products.'
                    : <></>
                }
            </FormHelperText>
        </FormControl>
        
        <FormControl>
            <InputLabel label={'Do you use a personal car?'} />
            {/* <FormHelperText>{'(>3 times a week)'}</FormHelperText> */}
            <ToggleButtonGroup
                fullWidth
                exclusive
                value={regularCarUse}
                onChange={(e,v) => setRegCarUse(v)}
                sx={{ borderRadius: '32px' }}
            >
                <ToggleButton className='rounded-toggle-btn' value={true}>Yes</ToggleButton>
                <ToggleButton className='rounded-toggle-btn' value={false}>No</ToggleButton>
            </ToggleButtonGroup>
        </FormControl>

        
        <FormControl>
            <InputLabel label={<>How much do you spend on EATING OUT <b>monthly</b>?</>} />
            <Box className="spread-x">
                <FormHelperText>Inclusive of restaurants, fast foods, hawker centers, etc.</FormHelperText>
                <InfoPopup content={"If you eat out as a family, divide the total cost by the number of family members."} />
            </Box>
            <InputField 
                value={eatOutExpInput}
                setValue={setEatOut} 
                options={eatoutOptions}
                startAdornment={'$'}
                isNumeric={true}
            />
        </FormControl>
        <FormControl>
            <InputLabel label={<>How much do you spend on EATING IN <b>monthly</b>?</>} />
            <Box className="spread-x">
                <FormHelperText>Inclusive of groceries, non-alcoholic beverages.</FormHelperText>
                <InfoPopup content={"If you know only household level expenses, divide the total cost by the number of family members."} />
            </Box>
            <InputField 
                value={eatInExpInput}
                setValue={setEatIn} 
                options={eatoutOptions}
                startAdornment={'$'}
                isNumeric={true}
            />
        </FormControl>

        <FormControl>
            <InputLabel label={<>How much do you spend on TRANSPORTATION <b>monthly</b>?</>} />
            <Box className="spread-x">
                <FormHelperText>Inclusive of bus and MRT rides, car leasing & COE, petrol, tolls & fees, and air flight tickets.</FormHelperText>
                <InfoPopup content={"If you use the family car, divide the cost by number of family members."} />
            </Box>
            <InputField 
                value={transportExpInput}
                setValue={setTransport} 
                options={transportRecreationOptions}
                startAdornment={'$'}
                isNumeric={true}
            />
        </FormControl>

        <FormControl>
            <InputLabel label={<>How much do you spend on RECREATION <b>monthly</b>?</>} />
            <Box className="spread-x">
                <FormHelperText>Inclusive of packaged holidays, entertainment, hobbies, outdoor activities, fitness and wellness activities, cultural activities, etc.</FormHelperText>
                <InfoPopup content={"If you travel as a family, divide the total cost by the number of family members."} />
            </Box>
            <InputField 
                value={recreationExpInput}
                setValue={setRecreation} 
                options={transportRecreationOptions}
                startAdornment={'$'}
                isNumeric={true}
            />
        </FormControl>
        <FormControl>
            <InputLabel label={<>How much do you spend on UTILITIES <b>monthly</b>?</>} />
            <FormHelperText>Exclusive of rent/leasing. Inclusive of electricity, water, gas, waste, and unit maintenance.</FormHelperText>
            <InputField 
                value={utilitiesExpInput}
                setValue={setUtils} 
                options={utilsOptions}
                startAdornment={'$'}
                isNumeric={true}
            />
        </FormControl>
        </>
    )
}